module.exports = __webpack_public_path__ + "static/media/wabi.1344929a.svg";